module.exports = __webpack_public_path__ + "static/media/tokentrack_cover.3f88461c.png";